import React from "react";
import { Container, Button, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import palette from "../../lib/styles/palette";

const FormDiv = styled.div`
  height: 100vh;
  background: ${palette.gray[2]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const LogoutForm = ({ onClickYes, onClickNo }) => {
  return (
    <div className="Logout">
      <Container fluid="md">
        <FormDiv>
          <Row>
            <h1>로그 아웃 하시겠습니까?</h1>
          </Row>
          <Row className="p-5">
            <Col>
              <Button onClick={onClickYes} style={{ width: "100px" }}>
                예
              </Button>
            </Col>
            <br />
            <Col>
              <Button onClick={onClickNo} style={{ width: "100px" }}>
                아니오
              </Button>
            </Col>
          </Row>
        </FormDiv>
      </Container>
    </div>
  );
};

export default LogoutForm;
